exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".setupChecklistModal .checklist{display:flex;flex-direction:column;justify-content:center}.setupChecklistModal .checklist .checklistItem{display:flex;margin:.1rem;padding:1rem;border-radius:1rem}.setupChecklistModal .checklist .failed{background-color:#f0a0a0;color:red}.setupChecklistModal .checklist .passed{background-color:#90ee90;color:green}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/appdev/wizards/setup_checklist_modal.scss
// module id = 832
// module chunks = 0